module.exports = __webpack_public_path__ + "images/car.ccba9cd351d93f7a85cd631d699338d0.png";